import { withCompInfo } from '@wix/editor-elements-integrations'
import { colorApi } from '@wix/thunderbolt-becky-root'
import { HeaderContainerCss, HeaderContainerDefinition } from './HeaderContainer'

export const css = withCompInfo<HeaderContainerCss, HeaderContainerDefinition>()(
	['styleProperties', 'compLayout', 'siteColors'],
	({ styleProperties, compLayout, siteColors }) => {
		const isFixedPosition = compLayout.fixedPosition
		const brightnessParams = colorApi.getBrightnessCSSVars({
			siteColors,
			styleProperties,
		})
		const style =
			(isFixedPosition && {
				position: 'fixed !important' as const,
				'margin-top': 'var(--wix-ads-height)' as const,
				top: '0' as const,
			}) ||
			(compLayout.y && {
				'margin-top': `${compLayout.y}px`,
			})
		return {
			...brightnessParams,
			...style,
		}
	}
)
